// import the styles for whole app
import './scss/bootstrap.scss';
import './scss/nc4.scss';
import './scss/utilities.scss';
// Tailwind is imported AFTER Bootstrap so its utilities win the cascade during migration
import './scss/tailwind.css';

// datepicker
import "flatpickr/dist/themes/light.css";
import 'react-date-range/dist/styles.css'; // main css file
//import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-loading-skeleton/dist/skeleton.css'; //skeleton loading
import React from 'react';
import {Provider as ReduxProvider} from 'react-redux';
import {ErrorBoundary, Provider as RollbarProvider} from '@rollbar/react'

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './utils/snowplow';

import Router from 'components/router/Router.component.jsx';
import store from 'components/store/Store.component.jsx';
import {AppTooltip} from 'components/tooltip/AppTooltip.component.jsx';
import {createRoot} from 'react-dom/client';
import {launchDarkly} from "utils/launchDarkly.ts";
import {buildRollbarConfig} from "utils/rollbarConfig.function.ts";


const rollbarConfig = buildRollbarConfig(window.ENVIRONMENT);


const App = () => {
    return (<RollbarProvider config={rollbarConfig}>
        <ErrorBoundary>
            <ReduxProvider store={store}>
                <Router/>
                {/* The single ReactTooltip instance every `<Tooltip>` trigger points at. */}
                <AppTooltip/>
                <ToastContainer
                    position={'top-right'}
                    autoClose={2500}
                    hideProgressBar={true}
                    draggable
                    closeButton={false}
                />
            </ReduxProvider>
        </ErrorBoundary>
    </RollbarProvider>);
}

const container = document.getElementById('root');
launchDarkly.createAnonymousClient().then(() => {
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<App/>);
});
